
define('ldsh!modules/domain_listing/templates/empty_view', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-hero">\n  <img alt="No Domains"\n    src="https://static.mdirector.com/assets/themes/vEmBlue/globals/src/images/assets/deliveries-no-content.svg">\n  <h2 class="mt16" data-i18n="domainListing.empty"></h2>\n\n\n  <div class="flex align-center justify-center mt32 mb32">\n    <div>\n      <button type="button" class="btn--primary--alt js-add-domain" data-i18n="domainListing.add" data-bypass></button>\n    </div>\n  </div>\n\n  <div class="md__block__support">\n    <div class="md__block__support__header">\n      <p class="bold" data-i18n="common.needHelp"></p>\n      <p data-i18n="domainListing.tip"></p>\n      <p class="mb0">\n        <span data-i18n="[html]domainListing.example"></span>\n        <a href="' +
((__t = ( configLink )) == null ? '' : __t) +
'" data-i18n="domainListing.howTo"></a>\n      </p>\n    </div>\n    <div class="md__block__support__footer">\n      <p>\n        ' +
((__t = ( contactUs )) == null ? '' : __t) +
'\n      </p>\n    </div>\n  </div>\n</div>';

}
return __p
};});

